export default __webpack_public_path__ + "media/zurb/img/events/wired/rcs/rcs-3-ecbe6e7c97b598fed3562243d640ab23.jpg";